import { Spacing } from 'Themes/spacing';

import { Skeleton } from '@/libs/shared/ui';

import {
  ActionButtonsContainer,
  CourseDateRow,
  DateTimePickerContainer,
  FormContainer
} from '../styled';

// Helper components to reduce duplication
const FormFieldSkeleton = () => <Skeleton variant="rectangular" width="100%" height={56} />;

const CheckboxOptionSkeleton = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: Spacing.small }}>
    <Skeleton variant="rectangular" width={20} height={20} />
    <Skeleton variant="text" width="60%" height={20} />
  </div>
);

const DateTimeInputGroup = () => (
  <div style={{ display: 'flex', gap: Spacing.xsmall }}>
    <Skeleton variant="rectangular" width={160} height={56} />
    <Skeleton variant="rectangular" width={100} height={56} />
  </div>
);

export const LoadingSkeleton = () => (
  <FormContainer>
    {/* Organization Field */}
    <FormFieldSkeleton />

    {/* Course Title Field */}
    <FormFieldSkeleton />

    {/* Participants Row - 3 fields in a row */}
    <div style={{ display: 'flex', gap: Spacing.medium, alignItems: 'center' }}>
      <div style={{ flex: 1 }}>
        <FormFieldSkeleton />
      </div>
      <div style={{ flex: 1 }}>
        <FormFieldSkeleton />
      </div>
      <div style={{ flex: 1 }}>
        <FormFieldSkeleton />
      </div>
    </div>

    {/* Timezone Field */}
    <FormFieldSkeleton />

    {/* Course Dates Section - matches actual DateTimePickerRange layout */}
    <CourseDateRow>
      <DateTimePickerContainer>
        {/* DateTime picker range structure - flexible for combined/separate modes */}
        <div
          style={{
            display: 'flex',
            gap: Spacing.small,
            alignItems: 'flex-end',
            flexWrap: 'wrap',
            minHeight: 56
          }}
        >
          {/* Start date/time input group */}
          <DateTimeInputGroup />

          {/* Arrow separator */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: `${Spacing.small} 0`,
              minHeight: 56
            }}
          >
            <Skeleton variant="circular" width={24} height={24} />
          </div>

          {/* End date/time input group */}
          <DateTimeInputGroup />
        </div>

        {/* Error message space */}
        <div style={{ minHeight: 20, marginTop: 3, marginLeft: 14, marginRight: 14 }}>
          <Skeleton variant="text" width="40%" height={16} />
        </div>
      </DateTimePickerContainer>
      <ActionButtonsContainer>
        {/* Remove button skeleton - matches CompactButton style */}
        <Skeleton variant="rectangular" width={85} height={36} />
        {/* Add button skeleton - matches CompactButton style */}
        <Skeleton variant="rectangular" width={105} height={36} />
      </ActionButtonsContainer>
    </CourseDateRow>

    {/* Description Field */}
    <Skeleton variant="rectangular" width="100%" height={120} />

    {/* Checkbox Options Section */}
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: Spacing.small,
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: '4px',
        padding: Spacing.medium
      }}
    >
      <CheckboxOptionSkeleton />
      <CheckboxOptionSkeleton />
      <CheckboxOptionSkeleton />
    </div>

    {/* Form Buttons */}
    <div style={{ display: 'flex', gap: Spacing.medium, justifyContent: 'flex-end' }}>
      <Skeleton variant="rectangular" width={100} height={40} />
      <Skeleton variant="rectangular" width={150} height={40} />
    </div>
  </FormContainer>
);
